// extracted by mini-css-extract-plugin
export default {"auditTable":"Audit_auditTable__P+Ebj","audit":"Audit_audit__9gF3z"};